export const profile = {
  block: {
    user_info: {
      title: 'Your data'
    },

    company_info: {
      title: 'Company info'
    },

    change_password: {
      title: 'Change Password',
    }
  },

  form: {
    field: {
      email: {
        title: 'Email address',
        placeholder: ''
      },
      timezone: {
        title: 'Timezone'
      },
      phone: {
        title: 'Phone'
      },
      name: {
        title: 'Name'
      },
      company: {
        title: 'Company'
      },
      legal_name: {
        title: 'Legal name'
      },
      contract_number: {
        title: 'Contract number'
      },
      contract_date: {
        title: 'Contract date'
      },
      inn: {
        title: 'TIN'
      },
      bank_details: {
        title: 'Bank details'
      },
      password: {
        current: 'Password',
        new: 'New Password',
        new_confirm: 'Confirm password'
      }
    }
  }
};
